package one.healthium.log_water.ui.internal

import kotlin.math.max

internal data class LogWaterUiModel(
    val dailyAmount: Float,
    val currentValue: Float,
    val additionValue: Float = 0f,
) {
    val value = max(0f, currentValue + additionValue)
    val progress: Float = if (dailyAmount == 0f) 0f else value / dailyAmount
}
